import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=0aafc2a4&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=0aafc2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aafc2a4",
  null
  
)

export default component.exports